<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="row" v-if="!showSuccessMessage && !showErrorMessage && !showConfirmationMessage">
                    <div class="col-6">
                        <div class="card border border-secondary">
                            <div class="card-body text-secondary">
                                <h5 class="card-title text-secondary">Assigned</h5>
                                <data-table 
                                        :headings="salesRepCustomersHeadings"
                                        :data="salesRepCustomers"
                                        :hasActions="true"
                                        :hasCustomActionComponent="true"
                                        :pagingDetails="pagingSalesRepCustomersDetails"
                                        :increasePagingWidth="true"
                                        :stateChanged="assignedFilterStateChanged"
                                        @filterSearchClicked="onFilterSearchAssignedCustomersClicked"
                                        @pagingUpdated="onAssignedPaging">
                                    <template #filter>
                                        <div class="p-3">
                                            <div class="input-group pb-4">
                                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="assignedFilter.customerSearchQuery">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fas fa-search"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <active-inactive-radio-buttons :activeInactiveKey="assignedFilter.activeOrInactiveItems"
                                                                       :componentId="'assignedCustomerFilterRadioButtons'"
                                                                       @activeInactiveSelected="onAssignedActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </template>
                                    <template #actionComponent="{ companyId }">
                                        <button class="btn btn-link" @click="unassignCustomerFromSalesRep(companyId)"
                                                :disabled="assignedFilterStateChanged">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </template>
                                </data-table>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card border border-secondary">
                            <div class="card-body text-secondary">
                                <h5 class="card-title text-secondary">Unassigned</h5>
                                <data-table 
                                        :headings="salesRepCustomersHeadings"
                                        :data="unassignedCustomers"
                                        :hasActions="true"
                                        :hasCustomActionComponent="true"
                                        :pagingDetails="pagingUnassignedCustomersDetails"
                                        :increasePagingWidth="true"
                                        :stateChanged="unassignedFilterStateChanged"
                                        @pagingUpdated="onUnassignedPaging"
                                        @filterSearchClicked="onFilterSearchUnassignedCustomersClicked">
                                    <template #filter>
                                        <div class="p-3">
                                            <div class="input-group pb-4">
                                                <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="unassignedFilter.customerSearchQuery">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon1">
                                                        <i class="fas fa-search"></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <active-inactive-radio-buttons :activeInactiveKey="unassignedFilter.activeOrInactiveItems"
                                                                        :componentId="'unassignedCustomerFilterRadioButtons'"
                                                                        @activeInactiveSelected="onUnassignedActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </template>
                                    <template #actionComponent="{ companyId }">
                                        <button class="btn btn-link" @click="assignCustomerFromSalesRep(companyId)"
                                                :disabled="unassignedFilterStateChanged">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </template>
                                </data-table>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="!showSuccessMessage && !showErrorMessage && showConfirmationMessage">
                    You are about to assign/unassign customers to/from the sales rep. Are you sure you want to proceed?
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onSaveClick" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage && !showConfirmationMessage">SAVE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage && !showConfirmationMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage && !showConfirmationMessage" @click="clearMessageAlerts">OK</button>
                
                <button class="btn btn-primary" :disabled="loading" @click="onModalSaveClick" v-if="!showSuccessMessage && !showErrorMessage && showConfirmationMessage">Yes</button>
                <button class="btn btn-secondary" :disabled="loading" @click="showConfirmationMessage=false;" v-if="!showSuccessMessage && !showErrorMessage && showConfirmationMessage">No</button>
            </div>
        </div>
    </div>
</div>